import { SVGProps } from 'react';

export function OrderIcon({ height, width, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 28 22"
			fill="none"
			{...props}
		>
			<path
				d="M4.93666 5.42407L1.5 18.315L7.10988 21"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.0514 5.4241H22.6895C22.6992 5.41162 22.7048 5.4033 22.7048 5.4033L19.834 2.00825C19.2959 1.37168 18.4734 1 17.6025 1H13.9245C13.1687 1 12.4531 1.32314 11.9871 1.87511L9.02473 5.37834C9.02889 5.38527 9.04276 5.4033 9.06079 5.4241H4.93903L7.11225 21H27.2273L25.0541 5.4241H25.0514Z"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.08032 5.37846L10.0427 1.87523C10.51 1.32326 11.2243 1.00012 11.9801 1.00012H14.8357"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.1076 3.36313C17.1076 4.00664 16.5847 4.52949 15.9412 4.52949C15.2977 4.52949 14.7749 4.00664 14.7749 3.36313C14.7749 2.71963 15.2977 2.19678 15.9412 2.19678C16.5847 2.19678 17.1076 2.71963 17.1076 3.36313Z"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8582 5.42407H14.3131"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.05823 5.42407H12.6821"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.7906 14.9145H11.7837C11.5105 14.9145 11.351 14.7938 11.2913 14.5442C11.0029 13.3154 10.6562 11.8398 10.5327 11.3184C10.5105 11.2213 10.591 11.1311 10.6895 11.1422L16.4949 11.8024L22.3683 11.1325C22.4681 11.1214 22.5485 11.2116 22.525 11.3087C22.4015 11.8315 22.0534 13.3154 21.7663 14.5442C21.7081 14.7925 21.5472 14.9145 21.274 14.9145H11.8142H11.7879H11.7906Z"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.6882 5.42407H20.5621"
				stroke="white"
				strokeWidth="1.29506"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
